<template>
  <coozzy-card :title="$t('message.settings.tend.title')">
    <div
      v-if="loading"
      style="height: 30px">
      <coozzy-spinner />
    </div>
    <div
      v-else
      class="row">
      <div class="col-6">
        <coozzy-form-input
          v-model="dateString"
          :filter="'formatDate'"
          type="date"
          :name="$t('message.settings.tend.until') + '*'" />
      </div>
      <div
        class="col-6">
        <coozzy-button
          :disabled="loading || !dateString"
          class="mt-3"
          design="green"
          @click="getRentalIndexCSV()">
          {{ $t('message.generic.create') }}
        </coozzy-button>
      </div>
    </div>
  </coozzy-card>
</template>

<script lang="ts">
import Vue, { defineComponent } from 'vue'
import CoozzyCard from '@/framework/components/card/CoozzyCard.vue'
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner.vue'
import CoozzyButton from '@/framework/components/button/CoozzyButton.vue'
import ExportApi from '@/misc/apis/ExportApi'
import CoozzyFormInput from '@/framework/components/form/input/CoozzyFormInput.vue'
import { dateUtils } from '@/mixins/dateUtils'

export default defineComponent({
  name: 'TendExportSettings',
  components: { CoozzyFormInput, CoozzyButton, CoozzySpinner, CoozzyCard },
  mixins: [dateUtils],
  data() {
    return {
      dateString: null,
      loading: false
    }
  },
  methods: {
    getRentalIndexCSV() {
      this.loading = true
      const date = this.toObject(this.dateString)
      ExportApi.tendGetRentalIndexCSV(date)
        .then(data => {
          const blob = new Blob([data.csv], { type: 'text/csv' })
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = 'rental-index.csv'
          a.click()
          window.URL.revokeObjectURL(url)
          this.loading = false
          Vue.toasted.show(this.$t('message.settings.tend.success'), { type: 'success' })
        }).catch(() => {
          Vue.toasted.show(this.$t('message.settings.tend.error'), { type: 'error' })
          this.loading = false
      })
    }
  }
})
</script>

<style scoped lang="scss">

</style>
